import { render } from "./ModalDetalheOsAssistenciaPosVenda.vue?vue&type=template&id=8bba5338&scoped=true"
import script from "./ModalDetalheOsAssistenciaPosVenda.vue?vue&type=script&lang=js"
export * from "./ModalDetalheOsAssistenciaPosVenda.vue?vue&type=script&lang=js"

import "./ModalDetalheOsAssistenciaPosVenda.vue?vue&type=style&index=0&id=8bba5338&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bba5338"]])

export default __exports__